import type { LucideIcon } from 'lucide-react';
import * as Icons from 'lucide-react';

/** Les exports Lucide React sont des forwardRef (`object` + `$$typeof`), pas des `function`. */
function isLucideIconExport(val: unknown): val is LucideIcon {
  if (val == null) return false;
  if (typeof val === 'function') return true;
  return typeof val === 'object' && '$$typeof' in (val as object);
}

/** Résout une clé d’icône Lucide (saisie admin) vers un composant ; défaut Rocket. */
export function resolveHelpCenterIcon(iconKey: string): LucideIcon {
  const name = iconKey.trim() || 'Rocket';
  const Icon = (Icons as Record<string, unknown>)[name];
  if (isLucideIconExport(Icon)) {
    return Icon;
  }
  return Icons.Rocket;
}

/** Normalise la clé (casse simple) vers un nom d’export Lucide valide, sinon Rocket. */
export function normalizeHelpCenterIconKey(raw: string): string {
  const s = (raw ?? '').trim() || 'Rocket';
  if (isLucideIconExport((Icons as Record<string, unknown>)[s])) return s;
  const cap = s.charAt(0).toUpperCase() + s.slice(1);
  if (isLucideIconExport((Icons as Record<string, unknown>)[cap])) return cap;
  return 'Rocket';
}
